import Vue from 'vue';

export default {

  async fetchCompletionsByDprId({ commit }, dprId) {
    return Vue.axios.get(Vue.$url("completion/" + dprId + "/available"))
      .then((rsp) => commit("SET_COMPLETIONTABLE", rsp.data))

  },

}